import { render, staticRenderFns } from "./DeviceScreenshots.vue?vue&type=template&id=01d1aa7a"
import script from "./DeviceScreenshots.vue?vue&type=script&lang=ts"
export * from "./DeviceScreenshots.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports